import React, { memo } from 'react';
import { Col, Row, Typography } from 'antd';
import { Button, Card } from 'components/src';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { COLORS, routesName, useNavigation } from 'core';

const useStyle = createUseStyles<string, unknown, COLORS>(
  (colors) => ({
    text: {
      color: colors.gray03,
      padding: '0px 10px',
    },
    row: {
      marginBottom: '20px',
    },
  })
);
interface Props {
  campaignId: string;
  campainName: string;
  campainType: string;
  totalNumberCount: string;
  calledNumberPercent: string;
  answeredNumberPercent: string;
  serverName: string;
}

const ActiveCampain = memo<Props>(
  ({
    campaignId,
    campainName,
    campainType,
    totalNumberCount,
    calledNumberPercent,
    answeredNumberPercent,
    serverName,
  }) => {
    const classes = useStyle();
    const { _navigateWithParams } = useNavigation();
    const { i18n } = useTranslation();
    return (
      <div>
        <Card
          title={campainName}
          extra={
            <Button
              onClick={() => {
                _navigateWithParams(
                  'campaign/' + routesName.DASHBOARD,
                  {
                    id: campaignId,
                  }
                );
              }}
              style={{ border: '1px solid white' }}
            >
              {i18n.t('details')}
            </Button>
          }
        >
          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Col>
              <Row className={classes.row}>
                {i18n.t('campaignType')}:
                <Typography className={classes.text}>
                  {campainType}
                </Typography>
              </Row>
              <Row className={classes.row}>
                {i18n.t('totalNumberCount')}:
                <Typography className={classes.text}>
                  {totalNumberCount}
                </Typography>
              </Row>
            </Col>
            <Col>
              <Row className={classes.row}>
                {i18n.t('calledNumberPercent')}:
                <Typography className={classes.text}>
                  {calledNumberPercent}
                </Typography>
              </Row>
              <Row className={classes.row}>
                {i18n.t('answeredNumberPercent')}:
                <Typography className={classes.text}>
                  {answeredNumberPercent}
                </Typography>
              </Row>
            </Col>
            <Col xs={24}></Col>
            <Col>
              <Row className={classes.row}>
                {i18n.t('serverName')}:
                <Typography className={classes.text}>
                  {serverName}
                </Typography>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
);

export { ActiveCampain };
